export default __webpack_public_path__ + "static/media/goldenline.6ec75079.svg";